import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Technology = lazy(() => import('../pages/technology/page'));
const Company = lazy(() => import('../pages/company/page'));
const Dealer = lazy(() => import('../pages/dealer/page'));
const Showerhead = lazy(() => import('../pages/showerhead/page'));
const Generator = lazy(() => import('../pages/generator/page'));
const News = lazy(() => import('../pages/news/page'));
const FAQ = lazy(() => import('../pages/faq/page'));

// Generator products
const Inline4Page = lazy(() => import('../pages/generator/inline4/page'));
const KitchenPage = lazy(() => import('../pages/generator/kitchen/page'));
const PiccoloPage = lazy(() => import('../pages/generator/piccolo/page'));
const GardenPage = lazy(() => import('../pages/generator/garden/page'));
const Breeze3Page = lazy(() => import('../pages/generator/breeze3/page'));

// Showerhead products
const ShowersPage = lazy(() => import('../pages/showerhead/showers/page'));
const ShowerbPage = lazy(() => import('../pages/showerhead/showerb/page'));
const ShowercPage = lazy(() => import('../pages/showerhead/showerc/page'));
const KomorebiPage = lazy(() => import('../pages/showerhead/komorebi/page'));
const BonheurPage = lazy(() => import('../pages/showerhead/bonheur/page'));
const Ut3Page = lazy(() => import('../pages/showerhead/ut3/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/technology',
    element: <Technology />
  },
  {
    path: '/company',
    element: <Company />
  },
  {
    path: '/dealer',
    element: <Dealer />
  },
  {
    path: '/news',
    element: <News />
  },
  {
    path: '/faq',
    element: <FAQ />
  },
  {
    path: '/showerhead',
    element: <Showerhead />
  },
  {
    path: '/showerhead/showers',
    element: <ShowersPage />
  },
  {
    path: '/showerhead/showerb',
    element: <ShowerbPage />
  },
  {
    path: '/showerhead/showerc',
    element: <ShowercPage />
  },
  {
    path: '/showerhead/komorebi',
    element: <KomorebiPage />
  },
  {
    path: '/showerhead/bonheur',
    element: <BonheurPage />
  },
  {
    path: '/showerhead/ut3',
    element: <Ut3Page />
  },
  {
    path: '/generator',
    element: <Generator />
  },
  {
    path: '/generator/inline4',
    element: <Inline4Page />
  },
  {
    path: '/generator/kitchen',
    element: <KitchenPage />
  },
  {
    path: '/generator/piccolo',
    element: <PiccoloPage />
  },
  {
    path: '/generator/garden',
    element: <GardenPage />
  },
  {
    path: '/generator/breeze3',
    element: <Breeze3Page />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;